/*
  Comandă directă (calmare.ro): formular de comandă -> Google Apps Script -> Google Sheet.
  Folosit de sections/comanda-directa.liquid și de test_local/test_formular.html.
  Configurația vine din <script type="application/json" data-cd-config> din interiorul [data-cd-root].
  Creat de Claude, 2026-10-23. PROTOTIP: nepublicat.
*/
(function () {
  'use strict';

  var ATTR_KEY = 'cd_attr_v1';
  var ATTR_DAYS = 7;
  var ATTR_PARAMS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ttclid'];

  // ---------- utilitare ----------
  function store(kind) { try { return window[kind]; } catch (e) { return null; } }
  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function uuid() {
    if (window.crypto && crypto.randomUUID) return crypto.randomUUID();
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0; return (c === 'x' ? r : (r & 3 | 8)).toString(16);
    });
  }
  function money(v, cur) {
    var n = Number(v || 0);
    return n.toFixed(2).replace('.', ',').replace(/,00$/, '') + ' ' + (cur === 'RON' ? 'lei' : cur);
  }

  // Telefon românesc: acceptă 07xx xxx xxx, +40 7xx..., 0040 7xx..., 40 7xx..., cu spații/puncte/cratime.
  // Întoarce {national:'07xxxxxxxx', e164:'+407xxxxxxxx'} sau null.
  function normPhone(raw, allowLandline) {
    var d = String(raw || '').replace(/\D/g, '');
    if (d.indexOf('0040') === 0) d = d.slice(4);
    else if (d.indexOf('40') === 0 && d.length >= 11) d = d.slice(2);
    d = d.replace(/^0+/, '');
    var ok = /^7\d{8}$/.test(d) || (allowLandline && /^[23]\d{8}$/.test(d));
    return ok ? { national: '0' + d, e164: '+40' + d } : null;
  }

  // Atribuire first-touch: UTM + fbclid salvate 7 zile (vizitatorul poate reveni din alt link).
  function readAttribution() {
    var qs = new URLSearchParams(location.search);
    var fromUrl = {}, has = false;
    ATTR_PARAMS.forEach(function (k) { var v = qs.get(k); if (v) { fromUrl[k] = v.slice(0, 300); has = true; } });
    var ls = store('localStorage'), saved = null;
    try { saved = ls && JSON.parse(ls.getItem(ATTR_KEY) || 'null'); } catch (e) { saved = null; }
    if (saved && saved.exp < Date.now()) saved = null;
    if (has) {
      saved = { data: fromUrl, landing: location.href.slice(0, 500), referrer: document.referrer.slice(0, 300), exp: Date.now() + ATTR_DAYS * 864e5 };
      try { ls && ls.setItem(ATTR_KEY, JSON.stringify(saved)); } catch (e) {}
    }
    var out = saved ? saved : { data: {}, landing: location.href.slice(0, 500), referrer: document.referrer.slice(0, 300) };
    return out;
  }

  function fbcValue(attr) {
    var c = getCookie('_fbc');
    if (c) return c;
    var id = attr.data.fbclid;
    return id ? 'fb.1.' + Date.now() + '.' + id : '';
  }

  // ---------- pixel Meta ----------
  function ensurePixel(cfg) {
    if (!cfg.pixel_id || !cfg.load_pixel || window.fbq) return;
    /* eslint-disable */
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,document,'script','https://connect.facebook.net/en_US/fbevents.js');
    /* eslint-enable */
    window.fbq('init', cfg.pixel_id);
    window.fbq('track', 'PageView');
  }
  function track(name, params, eventId) {
    try { if (window.fbq) window.fbq('track', name, params, eventId ? { eventID: eventId } : undefined); } catch (e) {}
    // Pentru „Customer events” din Shopify (pixel personalizat), dacă e configurat.
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('cd_' + name.toLowerCase(), params); } catch (e) {}
  }

  // ---------- trimitere ----------
  function send(cfg, payload) {
    // „mock” = doar testul local. Fără endpoint configurat, nu pretindem că s-a trimis.
    if (cfg.endpoint === 'mock') {
      return new Promise(function (res) { setTimeout(function () { res({ ok: true, mock: true }); }, 500); });
    }
    if (!cfg.endpoint) return Promise.resolve({ ok: false, error: 'no_endpoint' });
    var body = JSON.stringify(payload);
    // text/plain = „simple request”, fără preflight CORS (Apps Script nu răspunde la OPTIONS).
    return fetch(cfg.endpoint, { method: 'POST', headers: { 'Content-Type': 'text/plain;charset=utf-8' }, body: body, redirect: 'follow' })
      .then(function (r) { return r.json(); })
      .catch(function () {
        // Fallback: răspunsul n-a putut fi citit (ex. browser in-app). Trimitem „orb” și considerăm trimis.
        try {
          if (navigator.sendBeacon && navigator.sendBeacon(cfg.endpoint, new Blob([body], { type: 'text/plain' }))) return { ok: true, beacon: true };
        } catch (e) {}
        return { ok: false, error: 'network' };
      });
  }

  // ---------- inițializare ----------
  function init(root) {
    var cfgEl = root.querySelector('script[data-cd-config]');
    if (!cfgEl) return;
    var cfg;
    try { cfg = JSON.parse(cfgEl.textContent); } catch (e) { return; }
    var form = root.querySelector('[data-cd-form]');
    var totalEl = root.querySelector('[data-cd-total]');
    var btn = form.querySelector('[type=submit]');
    var errBox = root.querySelector('[data-cd-error]');
    var started = Date.now();
    var attr = readAttribution();
    var eventId = uuid();
    var sentStart = false;

    ensurePixel(cfg);

    function selectedPkg() {
      var r = form.querySelector('input[name=cd_pkg]:checked');
      if (!r) return cfg.packages[0];
      return cfg.packages.filter(function (p) { return p.id === r.value; })[0] || cfg.packages[0];
    }
    function refresh() {
      var p = selectedPkg();
      if (totalEl) totalEl.textContent = money(p.price, cfg.currency);
      root.querySelectorAll('[data-cd-pkg]').forEach(function (el) {
        el.classList.toggle('is-on', el.getAttribute('data-cd-pkg') === p.id);
      });
    }
    form.addEventListener('change', function (e) { if (e.target.name === 'cd_pkg') refresh(); });
    refresh();

    // Butoanele de pe pagină duc la formular.
    root.addEventListener('click', function (e) {
      var go = e.target.closest('[data-cd-goto]');
      if (!go) return;
      e.preventDefault();
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setTimeout(function () { var i = form.querySelector('input[name=name]'); if (i) i.focus({ preventScroll: true }); }, 450);
    });

    form.addEventListener('focusin', function () {
      if (sentStart) return; sentStart = true;
      var p = selectedPkg();
      track('InitiateCheckout', { value: p.price, currency: cfg.currency, content_name: cfg.product, num_items: p.qty });
    });

    function setErr(field, msg) {
      var wrap = form.querySelector('[data-field="' + field + '"]');
      if (!wrap) return;
      wrap.classList.toggle('has-err', !!msg);
      var m = wrap.querySelector('.cd-err');
      if (m) m.textContent = msg || '';
    }

    function validate() {
      var v = {}, errs = {};
      ['name', 'phone', 'county', 'city', 'address'].forEach(function (k) {
        var el = form.elements[k]; v[k] = el ? String(el.value || '').trim().replace(/\s+/g, ' ') : '';
      });
      if (v.name.length < 3 || v.name.split(' ').length < 2) errs.name = 'Te rugăm să scrii numele și prenumele.';
      var ph = normPhone(v.phone, cfg.allow_landline);
      if (!ph) errs.phone = 'Număr invalid. Exemplu corect: 0722 123 456.';
      if (cfg.ask_address) {
        if (!v.county) errs.county = 'Alege județul.';
        if (v.city.length < 2) errs.city = 'Scrie localitatea.';
        if (v.address.length < 5) errs.address = 'Scrie strada și numărul (sau „sat”, nr. casei).';
      }
      ['name', 'phone', 'county', 'city', 'address'].forEach(function (k) { setErr(k, errs[k]); });
      return { values: v, phone: ph, errs: errs };
    }

    // Validare live pe telefon, după ce iese din câmp.
    var phoneEl = form.elements.phone;
    if (phoneEl) phoneEl.addEventListener('blur', function () {
      if (!phoneEl.value) return;
      var ph = normPhone(phoneEl.value, cfg.allow_landline);
      setErr('phone', ph ? '' : 'Număr invalid. Exemplu corect: 0722 123 456.');
      if (ph) phoneEl.value = ph.national.replace(/^(\d{4})(\d{3})(\d{3})$/, '$1 $2 $3');
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      if (errBox) errBox.hidden = true;
      var res = validate();
      var firstErr = Object.keys(res.errs)[0];
      if (firstErr) {
        var w = form.querySelector('[data-field="' + firstErr + '"]');
        if (w) { w.scrollIntoView({ behavior: 'smooth', block: 'center' }); var i = w.querySelector('input,select'); if (i) setTimeout(function () { i.focus(); }, 300); }
        return;
      }
      var p = selectedPkg();
      var payload = {
        token: cfg.token || '',
        event_id: eventId,
        hp: (form.elements.website && form.elements.website.value) || '',
        elapsed_ms: Date.now() - started,
        name: res.values.name,
        phone: res.phone.national,
        phone_e164: res.phone.e164,
        county: res.values.county,
        city: res.values.city,
        address: res.values.address,
        package_id: p.id,
        package_label: p.label,
        qty: p.qty,
        value: p.price,
        currency: cfg.currency,
        product: cfg.product,
        variant_id: p.variant_id || '',
        utm_source: attr.data.utm_source || '',
        utm_medium: attr.data.utm_medium || '',
        utm_campaign: attr.data.utm_campaign || '',
        utm_content: attr.data.utm_content || '',
        utm_term: attr.data.utm_term || '',
        fbclid: attr.data.fbclid || '',
        gclid: attr.data.gclid || '',
        ttclid: attr.data.ttclid || '',
        fbc: fbcValue(attr),
        fbp: getCookie('_fbp'),
        referrer: attr.referrer || '',
        landing_url: attr.landing || '',
        page_url: location.href.slice(0, 500),
        user_agent: navigator.userAgent.slice(0, 300)
      };

      btn.disabled = true;
      btn.classList.add('is-busy');
      send(cfg, payload).then(function (r) {
        if (!r || !r.ok) throw new Error((r && r.error) || 'server');
        var evParams = { value: p.price, currency: cfg.currency, content_name: cfg.product, content_type: 'product', content_ids: [String(p.variant_id || p.id)], num_items: p.qty };
        if (cfg.pixel_event === 'lead' || cfg.pixel_event === 'both') track('Lead', evParams, eventId);
        if (cfg.pixel_event === 'purchase' || cfg.pixel_event === 'both') track('Purchase', evParams, eventId);
        var dbg = root.querySelector('[data-cd-debug]');
        if (dbg && r.mock) { dbg.hidden = false; dbg.textContent = JSON.stringify(payload, null, 2); }
        if (cfg.thank_you_url) {
          location.href = cfg.thank_you_url + (cfg.thank_you_url.indexOf('?') < 0 ? '?' : '&') + 'pachet=' + encodeURIComponent(p.id);
          return;
        }
        var ok = root.querySelector('[data-cd-success]');
        ok.querySelector('[data-cd-s-name]').textContent = res.values.name.split(' ')[0];
        ok.querySelector('[data-cd-s-pkg]').textContent = p.label + ' (' + money(p.price, cfg.currency) + ')';
        ok.querySelector('[data-cd-s-phone]').textContent = res.phone.national.replace(/^(\d{4})(\d{3})(\d{3})$/, '$1 $2 $3');
        form.hidden = true;
        ok.hidden = false;
        ok.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }).catch(function () {
        btn.disabled = false;
        btn.classList.remove('is-busy');
        if (errBox) errBox.hidden = false;
        // Păstrăm local datele, ca să nu se piardă lead-ul dacă vizitatorul reîncearcă.
        try { var ls = store('localStorage'); ls && ls.setItem('cd_pending', JSON.stringify(payload)); } catch (e) {}
      });
    });

    // Butonul fix de jos dispare cât timp formularul e pe ecran (nu acoperă câmpurile).
    var sticky = root.querySelector('.cd-sticky');
    var formZone = root.querySelector('#comanda');
    if (sticky && formZone && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.hidden = en[0].isIntersecting; }, { threshold: 0.05 }).observe(formZone);
    }

    // Numărătoare inversă opțională (implicit oprită în secțiune).
    var cd = root.querySelector('[data-cd-countdown]');
    if (cd) {
      var mins = parseInt(cd.getAttribute('data-cd-countdown'), 10) || 15;
      var ss = store('sessionStorage'), end = 0;
      try { end = parseInt(ss.getItem('cd_end') || '0', 10); } catch (e) {}
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { ss.setItem('cd_end', String(end)); } catch (e) {} }
      var tick = function () {
        var left = Math.max(0, Math.round((end - Date.now()) / 1000));
        cd.textContent = String(Math.floor(left / 60)).padStart(2, '0') + ':' + String(left % 60).padStart(2, '0');
        if (left > 0) setTimeout(tick, 1000);
      };
      tick();
    }
  }

  // Expus pentru testele locale.
  window.ComandaDirecta = { normPhone: normPhone };

  function boot() { document.querySelectorAll('[data-cd-root]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
